export default "__VITE_ASSET__d1f06924__"